import "core-js/modules/es.array.reduce";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// import { transparentize } from '@theme-ui/color';
import * as brandColors from './brandColors';
var white = brandColors.white,
    electricBlue = brandColors.electricBlue,
    hoverBlue = brandColors.hoverBlue,
    concordBlue = brandColors.concordBlue,
    lighterBlue = brandColors.lighterBlue,
    lightestBlue = brandColors.lightestBlue,
    lightGray = brandColors.lightGray,
    gray = brandColors.gray,
    black = brandColors.black,
    silver = brandColors.silver,
    lightSmoke = brandColors.lightSmoke,
    smoke = brandColors.smoke,
    lightGraphite = brandColors.lightGraphite,
    graphite = brandColors.graphite; // Role based colors.
// The description is used by the generated design system documentation.

var colors = {
  brand: {
    color: brandColors,
    description: 'The brand specific colors'
  },
  text: {
    color: black,
    description: 'The main text color.'
  },
  background: {
    color: white,
    description: 'The main background color.'
  },
  primary: {
    color: electricBlue,
    description: 'Main actions, CTAs, links, display colors.'
  },
  onPrimary: {
    color: white,
    description: 'A readable color when used with the primary color as the background, for example for buttons.'
  },
  secondary: {
    color: hoverBlue,
    description: 'Main hover colors. Only used as a hover.'
  },
  onSecondary: {
    color: white,
    description: 'A readable color when used with the secondary color as the background, for example for buttons.'
  },
  accent: {
    color: concordBlue,
    description: 'Backgrounds. Display text.'
  },
  onAccent: {
    color: lighterBlue,
    description: 'Background, text over concord blue. Iconography'
  },
  onDark: {
    color: white,
    description: 'A text color to use on dark or colored backgrounds.'
  },
  border: {
    color: lightGray,
    description: 'A color for thin and light borders of UI elements.'
  },
  borderSecondary: {
    color: gray,
    description: 'A secondary border color, e.g. for hovering over list items.'
  },
  borderNuanced: {
    color: lightSmoke,
    description: 'A very well visible border color, e.g. for hovering over outline buttons.'
  },
  white: {
    color: white,
    description: 'Pure white. For dark mode, this should be set to a dark tone. (TODO not really sure yet)'
  },
  black: {
    color: black,
    description: 'Pure black. For dark mode, this should be set to white. (TODO not sure about that yet)'
  },
  light: {
    color: silver,
    description: 'A very light background color, used for sections with white content blocks on it, for example on the homepage.'
  },
  nuanced: {
    color: lightGray,
    description: 'A nuanced background color, used for sections that have to stand out more.'
  },
  title: {
    color: graphite,
    description: 'The text color for titles.'
  },
  selected: {
    color: lightestBlue,
    description: 'A background color for selected items, like rows or list items'
  },
  lightText: {
    color: lightGraphite,
    description: 'A text color as a variant that is a bit lighter than the main text color. Used as text color on light background.'
  },
  lighterText: {
    color: smoke,
    description: 'A text color for discernably lighter text.'
  },
  lightestText: {
    color: lightSmoke,
    description: 'A text color for very light text, for example input placeholders.'
  },
  overlay: {
    color: 'rgba(0, 0, 0, 0.4)',
    description: 'A color for image overlays. Used to make onDark text more readable.'
  },
  overlaySecondary: {
    color: 'rgba(0, 0, 0, 0.6)',
    description: 'A secondary color for image overlays, used for hovering.'
  },
  skeleton: {
    color: lightestBlue,
    description: 'A color used for skeleton components'
  },
  skeletonDark: {
    color: lighterBlue,
    description: 'A color used for the animation of the skeleton components'
  }
};
/**
 * The theme colors as a map.
 * @returns {Object} A map of colors and their values, e.g. { text:'black', background:'transparent' }.
 */

export default Object.entries(colors).reduce( // Convert the `{ color,description }` objects to a simple object with key/value pairs.
function (colors, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      color = _ref2[1].color;

  return _objectSpread(_objectSpread({}, colors), {}, _defineProperty({}, key, color));
}, {});
export var colorsWithDescription = colors;